import { render, staticRenderFns } from "./safesDeposit.vue?vue&type=template&id=037ba0b2&"
import script from "./safesDeposit.vue?vue&type=script&lang=js&"
export * from "./safesDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports